import { create } from 'zustand';
import type { HomesQuery } from '../api/client.js';

// Per-channel "the Homes screener's current filters", so a Map on the same channel plots exactly the homes the
// screener lists (Alex 2026-10-16: a Map linked to the home panels shows home pins only). Same channel key as
// catchment-link / select-link (`${tabId}:${groupId}`). Kept out of the persisted app store: it is derived state
// the Homes panel republishes on mount.

interface HomesFilterLinkState {
  byKey: Record<string, HomesQuery | null>;
  setFor: (key: string, q: HomesQuery | null) => void;
}

export const useHomesFilterLink = create<HomesFilterLinkState>((set) => ({
  byKey: {},
  setFor: (key, q) => set((s) => ({ byKey: { ...s.byKey, [key]: q } })),
}));
